import HowToModal from './HowToModal';

export default HowToModal;
